import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useFamilyAllowanceChartsDataContext } from './hooks/useFamilyAllowanceChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel';

export const FamiliesPerMonth = () => {
    const { chartData } = useFamilyAllowanceChartsDataContext();

    const rawData = chartData.families.monthly;

    const series = [
        {
            name: 'Valor Médio por Família',
            data: rawData.map(item => Number(item.value))
        }
    ];

    const isYearComparison =
        rawData.length > 0 &&
        rawData.every(item => item.mes === rawData[0].mes);

    const formattedSubtitles = isYearComparison
        ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`)
        : rawData.map(item => getMonthLabel(item.mes));

    return (
        <SimpleBars
            title="Famílias Beneficiárias - Mensal"
            horizontal={false}
            subtitles={formattedSubtitles}
            series={series}
        />
    );
};
